import React from 'react';
import { motion } from 'framer-motion';
import { whyItems } from '../data/benefits';
export function WhyEducators() {
  return <section className="py-16 px-4 bg-stone-100 border-y border-stone-200" data-id="element-333" data-mp="k1i0zm4yr7xr">
      <div className="max-w-7xl mx-auto" data-id="element-334" data-mp="f0c91qj4nopa">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-800 text-center mb-10" data-id="element-335" data-mp="f36u9k9ytdjr">
          Why Makeup Educators Need a System Like This
        </h2>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-336" data-mp="61h046op80ia">
          {whyItems.map((item, i) => {
          const Icon = item.icon;
          return <motion.article key={item.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="bg-white border border-stone-200 p-6 rounded-2xl flex flex-col h-full" data-id="element-337" data-mp="3sg05xezly7d5" data-mpi={i}>
                <div className="w-10 h-10 rounded-full bg-rose-700 text-white flex items-center justify-center shrink-0 mb-4" data-id="element-338" data-mp="11i0tew9otedq">
                  <Icon size={18} aria-hidden="true" data-id="element-339" data-mp="15jvubznphpqz" />
                </div>
                <h3 className="font-sans font-bold text-sm uppercase tracking-wider text-rose-800 mb-2" data-id="element-340" data-mp="1t8f30gao44jl">
                  {item.title}
                </h3>
                <p className="text-stone-600 text-sm leading-relaxed" data-id="element-341" data-mp="1y5nk0dk2y2j9">
                  {item.text}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}